export const inverterIntegers = [];
export const inverterFloats = [];
export const inverterIsoStrings = [];
export const inverterWhiteList = ['id', 'name', 'siteId'];
export const inverterOptimisticList = [...inverterWhiteList, 'site', 'tables'];
